import request from '@/utils/request'
let preBase = 'mixApi'

// 厦门国际银行升金有礼-登录
export const login = (data) => {
  return request({
    url: `${preBase}/xibSaveMoney/login`,
    method: 'post',
    data,
    custom: true,
    hideLoading: true,
  })
}
// 厦门国际银行升金有礼-报名
export const apply = (data) => {
  return request({
    url: `${preBase}/xibSaveMoney/apply`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankAscendGoldToken'),
    data,
  })
}
// 厦门国际银行升金有礼-查询达标天数
export const getStandardDays = (data) => {
  return request({
    url: `${preBase}/xibSaveMoney/getStandardDays`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankAscendGoldToken'),
    data,
  })
}
// 厦门国际银行升金有礼-查询用户信息
export const getUserInfo = (data) => {
  return request({
    url: `${preBase}/xibSaveMoney/getUserInfo`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankAscendGoldToken'),
    data,
  })
}
// 厦门国际银行升金有礼-抽奖
export const lottery = (data) => {
  return request({
    url: `${preBase}/xibSaveMoney/lottery`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankAscendGoldToken'),
    data,
    hideLoading: true,
  })
}
// 厦门国际银行升金有礼-我的奖品
export const myPrize = (data) => {
  return request({
    url: `${preBase}/xibSaveMoney/myPrize`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankAscendGoldToken'),
    data,
  })
}
// 厦门国际银行升金有礼-获取openid
export const getOpenId = (data) => {
  return request({
    url: `${preBase}/xibSaveMoney/getOpenId`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankAscendGoldToken'),
    data,
  })
}
// 厦门国际银行升金有礼-查询抽奖信息
export const getLottery = (data) => {
  return request({
    url: `${preBase}/xibSaveMoney/getLottery`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankAscendGoldToken'),
    data,
  })
}
// 厦门国际银行升金有礼-领取奖品
export const getPrize = (data) => {
  return request({
    url: `${preBase}/xibSaveMoney/getPrize`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankAscendGoldToken'),
    data,
  })
}
// 厦门国际银行升金有礼-查询抽奖规则
export const getLotteryRule = (data) => {
  return request({
    url: `${preBase}/xibSaveMoney/getLotteryRule`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankAscendGoldToken'),
    data,
  })
}
// 厦门国际银行升金有礼-分享
export const share = (data) => {
  return request({
    url: `${preBase}/xibSaveMoney/share`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankAscendGoldToken'),
    data,
  })
}
// 厦门国际银行升金有礼-埋点
export const addPointData = (data) => {
  return request({
    url: `${preBase}/xibSaveMoney/addPointData`,
    method: 'post',
    token: sessionStorage.getItem('xiameBankAscendGoldToken'),
    data,
  })
}